/* tslint:disable */
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import React from 'react';
import theme from '../styles/theme';
import chevron from '../icons/smartdraw/chevron-black.svg';

const StyledAnchor = styled('a')`
  font-family: 'Apercu Pro Regular', sans-serif;
  display: inline-block;
  cursor: pointer;
  border-radius: 4px;
  border-width: 1px;
  font-weight: 500;
  color: ${theme.colors.Teal100};
  border-color: ${theme.colors.Teal100};
  background-color: ${theme.colors.Teal12};
  padding: 0.8em 1em;
  text-decoration: none;
`;

const StyledLink = styled(Link)`
  font-family: 'Apercu Pro Regular', sans-serif;
  display: inline-block;
  cursor: pointer;
  border-radius: 4px;
  border-width: 1px;
  font-weight: 500;
  color: ${theme.colors.Teal100};
  border-color: ${theme.colors.Teal100};
  background-color: ${theme.colors.Teal12};
  padding: 0.8em 1em;
  text-decoration: none;
`;

const LinkButton = (props) => {
  if (props.href || String(props.to).startsWith('http')) {
    // @ts-ignore
    const anchorProps = { ...props, href: props.to || props.href };
    delete anchorProps.to;

    return <StyledAnchor {...anchorProps} onClick={props.onClick}>{props.children}</StyledAnchor>;
  }
  return <StyledLink {...props} onClick={props.onClick}/>
};

export default LinkButton;

export const BasicLinkButton = styled(LinkButton)`
  color: #000;
  background: transparent;
  margin: auto;
  padding: auto;
  line-height: inherit;
`;

export const DarkLinkButton = styled(LinkButton)`
  color: #fff;
  border-color: ${theme.colors.Teal100};
  background-color: ${theme.colors.Teal100};
  font-family: 'Apercu Pro Bold';
`;

export const LightLinkButton = styled(LinkButton)`
  color: ${theme.colors.Teal100};
  border: 1px solid ${theme.colors.Teal100};
  background-color: ${theme.colors.Teal12};
  font-family: 'Apercu Pro Bold';
`;

export const MintLinkButton = styled(LinkButton)`
  color: #000;
  background-color: ${theme.colors.Turquoise60};
  font-family: 'Apercu Pro Bold';
`;

export const PinkLinkButton = styled(LinkButton)`
  color: #fff;
  background-color: ${theme.colors.Red80};
  border-color: ${theme.colors.Red80};
`;

export const PinkLink = styled(LinkButton)`
  color: ${theme.colors.Red80};
  font-family: 'Apercu Pro Bold';
  background-color: transparent;
  line-height: 1;
  &:after {
    content: '';
    display: block;
    border: 1px solid ${theme.colors.Red80};
    margin-top: ${theme.spacing.small}px;
    width: 100%;
  }
`;

export const PrimaryButton = styled(LinkButton)`
  background-color: ${(p: ButtonProps) => (p.backgroundColor ? p.backgroundColor : '#0af7da')};
  border-radius: 3px;
  border: none;
  box-shadow: -2px 2px 0 0 ${(p: ButtonProps) => (p.shadowColor ? p.shadowColor : `#0b4b40`)};
  color: ${theme.colors.Black};
  cursor: pointer;
  display: inline-block;
  font-family: 'Apercu Pro Bold', sans-serif;
  font-size: 18px;
  min-width: ${theme.spacing.standard * 4}px;
  padding: ${theme.spacing.small * 2}px ${theme.spacing.standard}px;
  width: fit-content;
  text-decoration: none;

  &:hover,
  &:active,
  &:visited {
    color: ${theme.colors.Black};
  }

  &:after {
    content: url(${chevron});
    height: 100%;
    width: ${theme.spacing.standard}px;
    display: inline-block;
    margin-left: ${theme.spacing.small}px;
  }
`;

export interface ButtonProps {
  backgroundColor?: string;
  shadowColor?: string;
  onClick?: any;
  copy?: string;
}
